import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
  TextField,
  Grid,
  Card,
  IconButton,
  CardContent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  CircularProgress,
  TableRow,
  Typography,
  TableContainer,
  Chip,
  Button,
  Paper,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import {getInitials} from 'helpers';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {RTL} from 'components';
import Pagination from '@material-ui/lab/Pagination';
import {useDispatch, useSelector} from 'react-redux';
import {axios} from './../../../../axios';
import {Loading, showSnackbar} from 'redux/Action';
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import JalaliUtils from '@date-io/jalaali';
import {values} from 'underscore';
const useStyles = makeStyles((theme) => ({
  root: {},

  tableCol: {
    padding: 12,
    fontSize: 11,
  },
  iconBtn: {
    padding: 5,
  },
  content: {
    padding: 0,
    margin: 10,
  },
  inner: {
    minWidth: 1050,
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  actions: {
    justifyContent: 'flex-end',
  },
  name: {
    marginRight: theme.spacing(1),
  },
  tableContainer: {
    height: '80vh',
  },
  input: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    width: '100%',
    marginBottom: theme.spacing(1),

    backgroundColor: 'white',
  },

  gridToolbar: {
    // marginRight: 10,
    padding: 5,
  },
  inputGroup: {
    marginTop: theme.spacing(2),
  },
  button: {
    textAlign: 'center',
    width: '100%',

    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),

    color: '#273C75',
    // paddingLeft:25,
    // marginRight: theme.spacing(1),
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#273C75',
      color: 'white',
    },
  },
  buttonDel: {
    textAlign: 'center',
    width: '100%',

    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderColor: '#E65D62',
    color: '#E65D62',
    // paddingLeft:25,
    // marginRight: theme.spacing(2),
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#E65D62',
      borderColor: 'white',

      color: 'white',
    },
  },
}));

let filter_txt = '';

let initialGet = true;
const numberFormat = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const ListPaymentTable = (props) => {
  const {
    className,
    showEdit,
    ChangeId,
    showInfo,
    onDelete,
    selData,
    reload,
    edit,
    del,
    reloadFunc,
    ...rest
  } = props;

  const classes = useStyles(props);

  const convertNumbers2English = function(string) {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660;
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0;
      });
  };

  let Pr_inventory = useSelector((state) => state.permission);

  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [LastPage, setLastPage] = React.useState(1);
  const [Page, setPage] = React.useState(1);
  const [selectedDate, handleDateChange] = useState(null);
  const AllStaff=[{
    status:"1",
    title:'پرداخت موفق'
  },{
    status:"0",
    title:'پرداخت ناموفق'
  }]

  let sizeData = '';
  const [countData, setCountData] = useState('0');

  const [selectEndDate, handleEndDateChange] = useState(null);

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const handleChangePage = (event, value) => {
    setPage(value);
  };
  const [delFilter, setDelFilter] = useState(false);

  const [Allcities, setAllcities] = useState([]);
  const [AllTruck_types, setTruck_types] = useState([]);
  // const [AllStaff, setAllStaff] = useState([]);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [tracking_code, setTracking_code] = useState('');

  const [cell, setCell] = useState('');

  const [statusPay, setStatusPay] = useState('');
  const [statusTitlePay, setStatusTitlePay] = useState('');

  const current_role = useSelector((state) => state.role);

  const Get_ComponentProvince = async () => {
    try {
      const res = await axios.get('province', {
        headers: headers,
      });

      setAllcities(res.data.province);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, 'eeeeeeeee');
    }
  };

  const GetData = async () => {
    try {
      // const res = await axios.get('transactions');
      const res = await axios.get(
        `transactions?${cell != '' ? `cell=` + cell : ''}${
          statusPay != '' ? `&success=` + statusPay : ''
        }${tracking_code != '' ? `&tracking_code=` + tracking_code : ''}${
          selectedDate != null
            ? `&from=` +
              convertNumbers2English(selectedDate.format('YYYY-MM-DD'))
            : ''
        }${
          selectEndDate != null
            ? `&to=` +
              convertNumbers2English(selectEndDate.format('YYYY-MM-DD'))
            : ''
        }${`&page=` + Page}`,
        {
          headers: headers,
        }
      );
      if (
        selectedDate != null ||
        selectEndDate != null ||
        cell != '' ||
        tracking_code != '' ||
        statusPay != ''
      ) {
        setDelFilter(true);
      }
      dispatch(Loading());

      setLastPage(res.data.transactions.last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setCountData(res.data.transactions.total);
      setData(res.data.transactions.data);
      console.log('ddddddddd' + res.data.transactions);
    } catch (e) {
      dispatch(Loading());
      console.log(e);
    }

    //alert(res)
  };

  useEffect(() => {
    dispatch(Loading());
    GetData();
  }, [Page, reload]);

  const DeletefilterBtn = () => {
    handleDateChange(null);
    handleEndDateChange(null);
    setTracking_code('');
    setCell('');

    setStatusTitlePay('');
    setStatusPay('');

    setDelFilter(false);

    reloadFunc();
    setPage(1);
  };

  const handleKeyDown = (event) => {
    setPage(1);
    if (event.key === 'Enter') {
      filter_txt = event.target.value;
      setData([]);
      GetData();
      dispatch(Loading());
    }
  };

  const filterBtn = () => {
    if (
      selectedDate == null &&
      selectEndDate == null &&
      cell == '' &&
      tracking_code == '' &&
      statusPay == ''
    ) {
      dispatch(
        showSnackbar(true, 'error', 'جهت اعمال فیلتر یکی از موارد را وارد کنید')
      );
    } else {
      setPage(1);
      dispatch(Loading());
      GetData();
    }
  };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        {!isLoading ? (
          <>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
              <RTL>
                <Grid container>
                  <Grid
                    className={classes.gridToolbar}
                    alignItems="flex-start"
                    item
                    xs={6}
                    md={3}
                    sm={3}
                  >
                    <DatePicker
                      className={classes.input}
                      inputVariant="outlined"
                      okLabel="تأیید"
                      ampm={false}
                      cancelLabel="لغو"
                      label="از تاریخ"
                      maxDate={selectEndDate ? selectEndDate : undefined}
                      labelFunc={(date) =>
                        date ? date.format('jYYYY/jMM/jDD') : ''
                      }
                      value={selectedDate ? moment(selectedDate) : null}
                      onChange={(v) => {
                        handleDateChange(v);
                        // setError({ ...error, start_date: "" })
                      }}
                    />
                  </Grid>
                  <Grid
                    className={classes.gridToolbar}
                    alignItems="flex-start"
                    item
                    xs={6}
                    md={3}
                    sm={3}
                  >
                    <DatePicker
                      className={classes.input}
                      inputVariant="outlined"
                      okLabel="تأیید"
                      ampm={false}
                      cancelLabel="لغو"
                      label="تا تاریخ"
                      minDate={selectedDate ? selectedDate : undefined}
                      labelFunc={(date) =>
                        date ? date.format('jYYYY/jMM/jDD') : ''
                      }
                      value={selectEndDate ? moment(selectEndDate) : null}
                      onChange={(v) => {
                        handleEndDateChange(v);
                        // setError({ ...error, start_date: "" })
                      }}
                    />
                  </Grid>

                  <Grid
                    className={classes.gridToolbar}
                    alignItems="flex-start"
                    item
                    xs={6}
                    md={6}
                    sm={6}
                  >
                    <TextField
                      className={classes.input}
                      label="شماره تماس راننده"
                      variant="outlined"
                      value={cell}
                      // error={Boolean(error?.full_name)}
                      // helperText={(error?.full_name)}
                      onChange={(e) => {
                        setCell(e.target.value);
                      }}
                      name="full_name"
                    />
                  </Grid>

                  <Grid
                    className={classes.gridToolbar}
                    alignItems="flex-start"
                    item
                    xs={6}
                    md={6}
                    sm={6}
                  >
                    <TextField
                      className={classes.input}
                      label="شماره پیگیری "
                      variant="outlined"
                      value={tracking_code}
                      // error={Boolean(error?.full_name)}
                      // helperText={(error?.full_name)}
                      onChange={(e)=>{setTracking_code(e.target.value)}}
                      name="full_name"
                    />
                  </Grid>
                  {current_role == 'Super-Admin' ||
                  // (Pr_inventory.indexOf('staff.viewAny') !== -1 &&
                  Pr_inventory.indexOf('shipments.insertBy') !== -1 ? (
                    <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={6}
                      md={3}
                      sm={3}
                    >
                      <Autocomplete
                        noOptionsText="همچنین وضعیتی وجود ندارد"
                        options={AllStaff}
                        getOptionLabel={(option) => option.title}
                        value={{
                          title: `${statusTitlePay}`,
                        }}
                        onChange={(event, value) => {
                          if (value != null) {
                            setStatusPay(value.status);
                            setStatusTitlePay(value.title);
                          } else {
                            setStatusPay('');
                            setStatusTitlePay('');
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            className={classes.input}
                            {...params}
                            label="وضعیت پرداخت"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                  ) : (
                    ''
                  )}
                  <Grid
                    className={classes.gridToolbar}
                    alignItems="flex-start"
                    item
                    xs={delFilter ? 6 : 12}
                    sm={
                      delFilter
                        ? current_role == 'Super-Admin' ||
                          Pr_inventory.indexOf('shipments.insertBy') !== -1
                          ? 1
                          : 2
                        : 3
                    }
                  >
                    <Button
                      variant="outlined"
                      size="medium"
                      onClick={() => filterBtn()}
                      color="secondary"
                      className={classes.button}
                    >
                      <SearchIcon />
                    </Button>
                  </Grid>
                  {delFilter ? (
                    <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={6}
                      sm={
                        current_role == 'Super-Admin' ||
                        Pr_inventory.indexOf('shipments.insertBy') !== -1
                          ? 1
                          : 2
                      }
                    >
                      <Button
                        variant="outlined"
                        size="medium"
                        onClick={() => DeletefilterBtn()}
                        color="secondary"
                        className={classes.buttonDel}
                      >
                        <ClearIcon />
                      </Button>
                    </Grid>
                  ) : (
                    ''
                  )}
                </Grid>
              </RTL>
            </MuiPickersUtilsProvider>

            <>
              {data ? (
                data.length > 0 ? (
                  <>
                    <Chip
                      style={{
                        backgroundColor: '#6A3053',
                        width: 200,
                        color: 'white',
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        fontSize: 13,
                      }}
                      label={`${countData} بار یافت شد`}
                    />
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">تاریخ خرید</TableCell>
                            <TableCell align="center">نام پلن</TableCell>
                            <TableCell align="center">وضعیت پرداخت</TableCell>
                            <TableCell align="center">قیمت پلن(ريال)</TableCell>
                            <TableCell align="center">نام راننده</TableCell>
                            <TableCell align="center">شماره تماس</TableCell>
                            <TableCell align="center">شماره پیگیری</TableCell>
                            {/* {current_role == 'Super-Admin' ||
                            Pr_inventory.indexOf('shipments.insertBy') !==
                              -1 ? (
                              <TableCell align="center">کارمند</TableCell>
                            ) : (
                              <></>
                            )}
                            {current_role == 'Super-Admin' ||
                            Pr_inventory.indexOf('shipment.edit') != -1 ||
                            Pr_inventory.indexOf('shipment.remove') != -1 ? (
                              <TableCell align="center">عملیات</TableCell>
                            ) : (
                              ''
                            )} */}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {data.map((dataBar) => (
                            <TableRow hover key={dataBar.id}>
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {/* {data.created_at} */}
                                {jMoment(
                                  dataBar?.verify_transaction?.created_at
                                )
                                  .local('fa')
                                  .format('HH:mm jYYYY/jM/jD')}
                              </TableCell>
                              {/* <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {jMoment(
                                  dataBar?.verify_transaction?.created_at
                                )
                                  .local('fa')
                                  .format('HH:mm jYYYY/jM/jD')}
                              </TableCell> */}
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar?.driver_plan?.plan?.alias}
                              </TableCell>
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                <Chip
                                  style={
                                    dataBar?.verify_transaction?.success == '1'
                                      ? {
                                          backgroundColor: '#00b894',
                                          color: 'white',
                                          fontSize: 11,
                                        }
                                      : dataBar?.verify_transaction?.success ==
                                        '0'
                                      ? {
                                          backgroundColor: '#e65d62',
                                          color: 'white',
                                          fontSize: 11,
                                        }
                                      : {
                                          backgroundColor: '#B2BEC3',
                                          color: 'white',
                                          fontSize: 11,
                                        }
                                  }
                                  label={
                                    dataBar?.verify_transaction?.success == '1'
                                      ? 'پرداخت موفق'
                                      : dataBar?.verify_transaction?.success ==
                                        '0'
                                      ? 'پرداخت ناموفق'
                                      : 'نامشخص'
                                  }
                                />
                              </TableCell>
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {numberFormat(dataBar?.amount)}
                              </TableCell>

                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.user?.full_name}
                              </TableCell>
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.user?.cell}
                              </TableCell>
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar?.tracking_code}
                              </TableCell>
                              {/* <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.desc == null
                                  ? '-'
                                  : String(dataBar.desc).length > 10
                                  ? String(dataBar.desc).substring(0, 10) +
                                    '...'
                                  : String(dataBar.desc)}
                              </TableCell> */}

                              {/* {current_role == 'Super-Admin' ||
                              Pr_inventory.indexOf('shipments.insertBy') !==
                                -1 ? (
                                <TableCell
                                  className={classes.tableCol}
                                  align="center"
                                >
                                  {dataBar?.insert_by_user?.full_name ==
                                  dataBar?.staff?.user?.full_name
                                    ? dataBar?.staff?.user?.full_name
                                    : dataBar?.insert_by_user?.full_name == null
                                    ? ' - ' +
                                      '(' +
                                      dataBar.staff?.user?.full_name +
                                      ')'
                                    : dataBar?.insert_by_user?.full_name +
                                      '(' +
                                      dataBar.staff?.user?.full_name +
                                      ')'}
                                </TableCell>
                              ) : (
                                <></>
                              )} */}

                              {/* {current_role == 'Super-Admin' ||
                                Pr_inventory.indexOf('shipment.edit') != -1 ||
                                Pr_inventory.indexOf('shipment.remove') !=
                                  -1 ? (
                                  <TableCell align="center">
                                    {current_role == 'Super-Admin' ||
                                    Pr_inventory.indexOf('shipment.edit') !=
                                      -1 ? (
                                      <IconButton
                                        component="span"
                                        disabled={edit || del}
                                        style={
                                          edit || del
                                            ? {color: '#7f8c8d'}
                                            : {color: '#6c5ce7'}
                                        }
                                        onClick={() => {
                                          showEdit();
                                          ChangeId(dataBar.id);
                                        }}
                                      >
                                        <EditIcon />
                                      </IconButton>
                                    ) : (
                                      ''
                                    )}
                                    {current_role == 'Super-Admin' ||
                                    Pr_inventory.indexOf('shipment.remove') !=
                                      -1 ? (
                                      <IconButton
                                        disabled={edit || del}
                                        style={
                                          edit || del
                                            ? {color: '#7f8c8d'}
                                            : {color: '#E65D62'}
                                        }
                                        onClick={() => {
                                          onDelete();
                                          ChangeId(dataBar.id);
                                          selData(
                                            data
                                              .filter(
                                                (dt) => dt.id == dataBar.id
                                              )
                                              .map((filterData) => filterData)
                                          );
                                        }}
                                        component="span"
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    ) : (
                                      ''
                                    )}
                                  </TableCell> */}
                              {/* ) : (
                                  ''
                                )} */}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {LastPage > 1 ? (
                        <Pagination
                          style={{margin: 10}}
                          variant="outlined"
                          onChange={handleChangePage}
                          page={Page}
                          count={LastPage}
                          color="primary"
                        />
                      ) : (
                        ''
                      )}
                    </TableContainer>
                  </>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      alignItems: 'center',
                      padding: 50,

                      height: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
                  </div>
                )
              ) : (
                ''
              )}
            </>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              height: '100%',
              justifyContent: 'center',
            }}
          >
            <CircularProgress size={24} />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

ListPaymentTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
};

export default ListPaymentTable;
